import { render, staticRenderFns } from "./answerAndStudents.vue?vue&type=template&id=9ea3dc12&scoped=true"
import script from "./answerAndStudents.vue?vue&type=script&lang=js"
export * from "./answerAndStudents.vue?vue&type=script&lang=js"
import style0 from "./answerAndStudents.vue?vue&type=style&index=0&id=9ea3dc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea3dc12",
  null
  
)

export default component.exports